<template>
  <div class="cases-part1">
    <router-view></router-view>
    <div class="equipment-box">
      <div class="container">
        <div class="title">{{ $t("header.equipment") }}</div>
        <div class="cases-box">
          <div
            class="cases-item"
            v-for="(item, index) in casesList"
            :key="index"
            @click="toDetailPage(item.id)"
          >
            <div class="item-img">
              <img :src="item.url" class="img-fluid" alt="" />
            </div>
            <div class="item-con">
              <h5>{{ item.title }}</h5>
              <i></i>
              <p>
                {{ item.text }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      casesList: [
        
        //工程案例特色项目首页

        {
          id: 1,
          title: this.$t("home.chongqing"),
          text: this.$t("home.chongqing_txt1"),
          url: require("@/assets/image/cases-part1-1.png"),
        },
        {
          id: 2,
          title: this.$t("home.sichuan"),
          text: this.$t("cases.cases_1"),
          url: require("@/assets/image/cases-part1-2.png"),
        },
        {
          id: 3,
          title: this.$t("home.xinjian"),
          text: this.$t("cases.cases_2"),
          url: require("@/assets/image/cases-part1-3.png"),
        },
        {
          id: 4,
          title: this.$t("home.xizang"),
          text: this.$t("cases.cases_3"),
          url: require("@/assets/image/cases-part1-4.png"),
        },
        {
          id: 5,
          title: this.$t("home.dunhua"),
          text: this.$t("cases.cases_4"),
          url: require("@/assets/image/cases-part1-5.png"),
        },
        {
          id: 6,
          title: this.$t("home.hexin"),
          text: this.$t("cases.cases_5"),
          url: require("@/assets/image/cases-part1-6.png"),
        },
        {
          id: 7,
          title: this.$t("home.qiayang"),
          text: this.$t("cases.cases_6"),
          url: require("@/assets/image/cases-part1-7.png"),
        },
        {
          id: 8,
          title: this.$t("home.bulage"),
          text: this.$t("cases.cases_7"),
          url: require("@/assets/image/cases-part1-8.png"),
        },
        {
          id: 9,
          title: this.$t("home.shimen"),
          text: this.$t("cases.cases_8"),
          url: require("@/assets/image/cases-part1-9.png"),
        },
        {
          id: 10,
          title: this.$t("home.lake"),
          text: this.$t("cases.cases_9"),
          url: require("@/assets/image/cases-part1-10.png"),
        },
        
        
        {
          id: 12,
          title: this.$t("home.axiaoke"),
          text: this.$t("cases.cases_102"),
          url: require("@/assets/image/cases-part-axiaoke1.png"),
        },

        {
          id: 13,
          title: this.$t("home.batang"),
          text: this.$t("cases.cases_103"),
          url: require("@/assets/image/batang1.png"),
        },

        {
          id: 14,
          title: this.$t("home.hongshanxia"),
          text: this.$t("cases.cases_104"),
          url: require("@/assets/image/hongshanxia1.png"),
        },
        
        {
          id: 15,
          title: this.$t("home.hongyudong"),
          text: this.$t("cases.cases_105"),
          url: require("@/assets/image/hongyudong1.png"),
        },
        
        {
          id: 16,
          title: this.$t("home.xianghe"),
          text: this.$t("cases.cases_106"),
          url: require("@/assets/image/xianghe1.png"),
        },
        
        {
          id: 17,
          title: this.$t("home.yalong"),
          text: this.$t("cases.cases_107"),
          url: require("@/assets/image/yalong1.png"),
        },
        
        {
          id: 18,
          title: this.$t("home.yangjiang"),
          text: this.$t("cases.cases_108"),
          url: require("@/assets/image/yangjiang1.png"),
        },

        {
          id: 11,
          title: this.$t("home.jishu"),
          text: this.$t("cases.cases_10"),
          url: require("@/assets/image/cases-part1-11.png"),
        },



      ],
    };
  },
  watch: {},
  computed: {},
  methods: {
    toDetailPage(id) {
      this.$router.push({ path: "/cases/detail", query: { id: id } });
    },
  },
  created() {},
  mounted() {},
  destroyed() {},
};
</script>
<style lang="less" scoped>
.cases-part1 {
  overflow: hidden;
}
.title {
  background: url("../../assets/image/equipment-1.png") no-repeat;
  background-position: center;
  background-size: contain;
  font-size: 30px;
  font-weight: 800;
  font-style: italic;
  color: #054ea4;
  text-align: center;
  margin: 100px 0 50px 0;
}
.cases-box {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: 100px;
  &::after {
    display: block;
    content: "";
    width: 32%;
  }
}
.cases-item {
  background: #ffffff;
  margin-bottom: 20px;
  width: 32%;
  &:hover {
    box-shadow: 0px 0px 20px 0px rgba(5, 78, 164, 0.2);
    transform: translateY(1px);
  }
  .item-con {
    padding: 30px 20px;
    h5 {
      font-size: 18px;
      font-weight: bold;
      color: #333333;
    }
    i {
      display: block;
      width: 47px;
      height: 2px;
      background: #054ea4;
      margin: 15px 0;
    }
    p {
      font-size: 14px;
      font-weight: 400;
      line-height: 25px;
    }
  }
}

@media (max-width: 1024px) and (min-width: 768px) {
  .news-section .news-title {
    height: 50px;
    line-height: 50px;
  }
  .title {
    margin: 50px 0 25px 0;
    font-size: 18px;
  }
  .item-img {
    height: 108px;
    overflow: hidden;
    display: flex;
    align-items: flex-end;
  }
  .cases-item .item-con {
    padding: 11px 10px;
    i {
      margin: 8px 0;
    }
  }
}
@media (max-width: 767px) and (min-width: 320px) {
  .equipment-item .item-con {
    padding: 10px;
  }
  .cases-item {
    width: 49%;
    margin-bottom: 10px;
  }
  .title {
    margin: 25px 0;
    font-size: 18px;
  }
  .cases-item .item-con {
    padding: 11px 10px;
    i {
      margin: 8px 0;
      width: 24px;
    }
    h5 {
      font-size: 14px;
    }
    p {
      font-size: 12px;
      margin-bottom: 0;
    }
  }
  .cases-box {
    margin-bottom: 50px;
  }
}
</style>